var Handlebars = require("handlebars/runtime");
module.exports = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h1 class=\"app-loader-title\">"
    + container.escapeExpression((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"LOADING",{"name":"t","hash":{},"data":data}))
    + "..</h1>";
},"useData":true});



//////////////////
// WEBPACK FOOTER
// ./shared/view/AppLoader/AppLoader.hbs
// module id = 330
// module chunks = 46 47